import type { IServicesCollection } from 'src/packages/di';

import { AlertsPersonalPreferenceService } from './AlertsPersonalPreferenceService';
import type { IAlertsPersonalPreferenceService } from './IAlertsPersonalPreferenceService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    alertsPersonalPreference: IAlertsPersonalPreferenceService;
  }
}

export async function addAlertsPersonalPreferenceService(di: IServicesCollection) {
  const service = new AlertsPersonalPreferenceService();
  // await service.loadPreferences();

  di.addSingleton('alertsPersonalPreference', service);
}
